module.exports = __webpack_public_path__ + "img/icn-russian.f2f2d1a4.svg";